export const exhaustiveGuard = (x: never, message?: string): never => {
  throw new Error(`${message || "Unexpected object"}: ${x}`);
};

export const exhaustiveGuardNoError = (_x: never): void => {
  return;
};

export const exhaustiveGuardWithDefaultValue = <T>(
  _x: never,
  defaultValue: T
): T => {
  return defaultValue;
};
